<template>
    <div class="report">
      <div v-if="paperReport">
        <h1 class="title">《{{ paperReport.paperInfo.paperName }}》试卷报告</h1>
        <a-row class="info">
          <a-col :span="8">
            <ul class="base-info-list">
              <li>
                <span class="info-title">题目数量：{{ paperReport.paperInfo.questionCount }}</span>
              </li>
              <li>
                <span class="info-title">试卷分数：{{ paperReport.paperInfo.paperScore }}</span>
              </li>
              <li>
                <span class="info-title">平均分数：{{ paperReport.paperInfo.avgScore }}</span>
              </li>
            </ul>
          </a-col>
          <a-col :span="16">
            <div class="chart" id="score-dist" style="width: 100%; height: 400px"></div>
          </a-col>
        </a-row>
        <a-divider></a-divider>
  
        <div>
          <a-table :columns="columns" :dataSource="dataSource" :pagination="false">
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
              <a-row>
                <a-col :span="[1, 2, 3].includes(record.questionType) ? 8 : 24">
                  <div v-html-md="record.questionStem"></div>
                </a-col>
                <a-col :span="16" v-if="[1, 2, 3].includes(record.questionType)">
                  <a-table :columns="answerColumns" :data-source="record.questionOptions" :rowKey="(row,index)=>index" :pagination="false">
                    <span slot="percent" slot-scope="text, record">
                      <a-progress :percent="parseInt((record.count / record.total) * 100)" size="small" />
                    </span>
                    <div slot="options" slot-scope="text">
                      <span v-html-md="text"></span>
                    </div>
                  </a-table>
                </a-col>
              </a-row>
            </div>
            <div slot="answerDistSlot" slot-scope="text, record">
              <div v-if="record.answerDist">
                <span v-for="(a, i) in record.answerDist" :key="i">
                  {{ parseOptionSelete(a.name) }} : {{ a.count }}
                </span>
              </div>
            </div>
          </a-table>
        </div>
      </div>
      <div v-else>
        <a-spin></a-spin>
      </div>
  
      <!-- <a-row type="flex" :gutter="60" justify="space-around">
        <a-col :span="8">
          <div class="chart" id="main1" style="width: 300px; height: 300px"></div>
        </a-col>
        <a-col :span="8">
          <div class="chart" id="main2" style="width: 300px; height: 300px"></div>
        </a-col>
        <a-col :span="8">
          <div class="chart" id="main3" style="width: 300px; height: 300px"></div>
        </a-col>
      </a-row> -->
      <!-- <div class="chart" id="main4" style="width: 800px; height: 900px"></div> -->
    </div>
  </template>
  
  <script>
  import { getAction } from '@/api/manage'
  import * as echarts from 'echarts'
  export default {
    data() {
      return {
        paperId: '',
        paperReport: null,
        dataSource: null,
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            },
          },
          {
            title: '题目ID',
            dataIndex: 'questionId',
          },
          {
            title: '题型',
            dataIndex: 'questionType',
            width: 100,
            customRender(v) {
              switch (v) {
                case 1:
                  return '单选'
                case 2:
                  return '多选'
                case 3:
                  return '判断'
                case 4:
                  return '填空'
                case 5:
                  return '简答'
                case 6:
                  return '主观'
                case 7:
                  return '编程'
                case 8:
                  return 'OJ'
              }
            },
          },
          {
            title: '题目名',
            dataIndex: 'questionName',
          },
          {
            title: '得分率(总数/得分数)',
            dataIndex: 'questionScoringAverage',
            width: 180,
            customRender(v, r) {
              return Math.round(v * 100) + '% (' + r.gotScoreAnswerTotal + '/' + r.answerTotal + ')'
            },
            sorter: (a, b) => a.questionScoringAverage - b.questionScoringAverage,
          },
          {
            title: '答题分布',
            dataIndex: 'answerDist',
            width: 200,
            scopedSlots: { customRender: 'answerDistSlot' },
          },
        ],
        answerColumns: [
          {
            title: '#',
            dataIndex: 'letter',
            key: 'letter',
            width: 120,
            customRender(v, r) {
              if (r.right) {
                return v + ' (正解)'
              } else {
                return v
              }
            },
          },
          {
            title: '选项',
            dataIndex: 'item',
            key: 'item',
            scopedSlots: { customRender: 'options' },
          },
          {
            title: '小计',
            dataIndex: 'count',
            key: 'count',
            width: 100,
          },
          {
            title: '比例',
            key: 'percent',
            width: 200,
            scopedSlots: { customRender: 'percent' },
          },
        ],
      }
    },
    created() {
      this.paperId = this.$route.query.paperId
      getAction('/report/paperReport', { paperId: this.paperId }).then((res) => {
        for (let qi in res.result.questionsInfo) {
          let q = res.result.questionsInfo[qi]
          // console.log(q)
          if (q.questionOptions != null) {
            q.questionOptions = JSON.parse(q.questionOptions)
            //单选多选解析
            if (q.questionType == 1 || q.questionTYpe == 2) {
              for (let oi in q.questionOptions) {
                let o = q.questionOptions[oi]
                o['letter'] = this.parseOptionSelete(oi)
                o['total'] = q.answerTotal
                if (q.questionAnswer != null && q.questionAnswer.includes(oi)) {
                  o['right'] = true
                } else {
                  o['right'] = false
                }
                o['count'] = this.getNameCount(q.answerDist, oi + '')
              }
            }
            //判断题解析
            if (q.questionType == 3) {
              q.questionOptions = [
                {
                  letter: '正确',
                  total: q.answerTotal,
                  right: q.questionAnswer == 'true',
                  count: this.getNameCount(q.answerDist, 'true'),
                },
                {
                  letter: '错误',
                  total: q.answerTotal,
                  right: q.questionAnswer == 'false',
                  count: this.getNameCount(q.answerDist, 'false'),
                },
              ]
            }
          }
        }
        this.paperReport = res.result
        this.dataSource = this.paperReport.questionsInfo
        this.$nextTick(() => {
          this.renderChartScoreDist(this.paperReport.scoreDist)
        });
        window.document.title = `试卷报告:《${this.paperReport.paperInfo.paperName}》`
      })
    },
    mounted() {
      let that = this
    },
    methods: {
      //渲染分数分布
      renderChartScoreDist(data){
        console.log(data);
        let xData = data.map(item=>item.score)
        let yData = data.map(item=>item.count)
        console.log(xData,yData);
        let mychart = echarts.init(document.getElementById("score-dist"));
        mychart.showLoading();
        let option = {
            title: {
              text: '分数分布',
              left: 'center'
            },
            tooltip: {
              trigger: 'axis',
              formatter: '得分：{b0}: 人数：{c0}'
            },
            xAxis: {
              name: '人数',
              type: 'category',
              data: xData,
            },
            yAxis: {
              name: '得分',
              type: 'value'
            },
            series: [
            {
              data: yData,
              type: 'bar',
              barMaxWidth: 30, // 设置数据柱的最大宽度
              // itemStyle: {
              //   borderRadius: [50, 50, 0, 0] // 设置柱形的上方为圆角
              // },
              // label: {
              //   show: true,
              //   position: 'top',
              //   formatter: '{c}' // 显示数据值
              // }
            }
          ]
        }
        setTimeout(function () {
          mychart.setOption(option);
          mychart.hideLoading();
        }, 100);
      },
      parseOptionSelete(name) {
        if (name === 'null') {
          return '未作答'
        }
        if (name === 'true') {
          return '正确'
        }
        if (name === 'false') {
          return '错误'
        }
        let letters = name.split(',')
        let res = []
        try {
          for (let i = 0; i < letters.length; i++) {
            res.push(this.index2letter(parseInt(letters[i])))
          }
          return res.join(',')
        } catch (e) {
          return name
        }
      },
      getNameCount(list, name) {
        for (let i in list) {
          if (list[i]['name'] == name) {
            return list[i]['count']
          }
        }
        return 0
      },
      //索引转大写字母
      index2letter(index) {
        if (index == 'null') return '未作答'
        if (index < 0 || index > 25) {
          return ''
        }
        return String.fromCharCode(65 + index)
      },
    },
  }
  </script>
  
  <style scoped lang="less">
  .report {
    background: white;
    max-width: 1500px;
    margin: 20px auto;
  }
  .title {
    text-align: center;
    font-size: 30px;
  }
  .info {
    margin: 20px;
    .info-title {
      font-weight: bold;
    }
    .base-info-list {
      padding: 0;
      li {
        list-style-type: none;
        padding-left: 25px;
        margin: 10px 0;
        span {
          color: black;
          font-size: 16px;
        }
      }
    }
  }
  </style>